import { Checkbox, Collapse, Radio } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const LabResults: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    sectionName?: string;
}> = ({ rxConfig, saveRxConfigInState, sectionName }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 min-w-26 h-26 flex items-center justify-center bg-darwin-accent-bright-yellow-900">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            className="w-16 h-12 fill-white "
                            viewBox="0 0 9 13"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M5.21758 1.03906C5.03008 0.359375 4.0457 0.335938 3.83476 1.03906C2.75664 4.71875 0.412889 5.72656 0.412889 8.32812C0.412889 10.6484 2.24101 12.5 4.53789 12.5C6.81133 12.5 8.66289 10.6484 8.66289 8.32812C8.66289 5.72656 6.31914 4.74219 5.21758 1.03906ZM4.53789 11C3.08476 11 1.91289 9.82812 1.91289 8.39844C1.91289 8.21094 2.07695 8.02344 2.28789 8.02344C2.47539 8.02344 2.66289 8.21094 2.66289 8.39844C2.66289 9.45312 3.4832 10.25 4.53789 10.25C4.72539 10.25 4.91289 10.4375 4.91289 10.625C4.91289 10.8359 4.72539 11 4.53789 11Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel
                header={<div className="font-700">{sectionName || 'Investigative Readings'}</div>}
                key="1"
            >
                <p className="mr-16 space-y-4">
                    <div className="cursor-pointer flex flex-1 items-center justify-between">
                        <span className="font-700">Arrange By:</span>
                        {!rxConfig?.tabular_config?.['labVitals'] && (
                            <Radio.Group
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        lab_vitals_format: e.target.value,
                                    });
                                }}
                                value={rxConfig?.lab_vitals_format ?? ''}
                            >
                                <Radio value={''}>Test Name</Radio>
                                <Radio value={'date-data'}>Test Date</Radio>
                            </Radio.Group>
                        )}
                    </div>

                    <div>
                        <span className="font-700">Investigative readings style:</span>
                        <div className="cursor-pointer">
                            <p
                                className="cursor-pointer flex flex-1 items-center justify-between"
                                onClick={() => {
                                    saveRxConfigInState({
                                        lab_vitals_name_in_unbold: !rxConfig?.lab_vitals_name_in_unbold,
                                    });
                                }}
                            >
                                <span>Make tests names bold</span>
                                <Checkbox checked={!rxConfig?.lab_vitals_name_in_unbold}></Checkbox>
                            </p>
                        </div>
                        {!(rxConfig?.lab_vitals_format === 'date-data') && (
                            <div className="cursor-pointer">
                                <p
                                    className="cursor-pointer flex flex-1 items-center justify-between"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            tabular_config: {
                                                ...rxConfig?.tabular_config,
                                                ['labVitals']: false,
                                            },
                                            bullets_config: {
                                                ...rxConfig?.bullets_config,
                                                ['labVitals']: !rxConfig?.bullets_config?.[
                                                    'labVitals'
                                                ],
                                            },
                                        });
                                    }}
                                >
                                    <span>Use bullet points</span>
                                    <Checkbox
                                        checked={rxConfig?.bullets_config?.['labVitals']}
                                    ></Checkbox>
                                </p>
                            </div>
                        )}
                        <div className="cursor-pointer">
                            <p
                                className="cursor-pointer flex flex-1 items-center justify-between"
                                onClick={() => {
                                    saveRxConfigInState({
                                        bullets_config: {
                                            ...rxConfig?.bullets_config,
                                            ['labVitals']: false,
                                        },
                                        tabular_config: {
                                            ...rxConfig?.tabular_config,
                                            ['labVitals']: !rxConfig?.tabular_config?.['labVitals'],
                                        },
                                    });
                                }}
                            >
                                <span>Use tabular format</span>
                                <Checkbox
                                    checked={rxConfig?.tabular_config?.['labVitals']}
                                ></Checkbox>
                            </p>
                        </div>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.lab_vitals_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        lab_vitals_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            lab_vitals_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    {!rxConfig?.tabular_config?.['labVitals'] && (
                        <>
                            <div className="flex items-center justify-between">
                                <div>Key Elements</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.lab_vitals_name_color || '#000000'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                lab_vitals_name_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    lab_vitals_name_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <div>Properties</div>{' '}
                                <div className="flex space-x-12">
                                    <input
                                        type="color"
                                        id="head"
                                        name="head"
                                        value={rxConfig?.lab_vitals_properties_color || '#000000'}
                                        onChange={(e) => {
                                            saveRxConfigInState({
                                                lab_vitals_properties_color: e.target.value,
                                            });
                                        }}
                                        className="circular-color-input"
                                    />

                                    <AntTooltip content="Reset">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                            onClick={() => {
                                                saveRxConfigInState({
                                                    lab_vitals_properties_color: '',
                                                });
                                            }}
                                        >
                                            <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                        </svg>
                                    </AntTooltip>
                                </div>
                            </div>
                        </>
                    )}
                </p>
            </Panel>
        </Collapse>
    );
};

export default LabResults;
